import styled from 'styled-components'

export const QuestionListItemDeleteUi = styled.span`
  cursor: pointer;
  color: red;
`
